// Plan (SuperAdmin sidebar catalog) gating for routes - extracted from routes/newRoutes.js.

// Maps route paths to the same slugs used in the SuperAdmin plan HRMS_SIDEBAR_CATALOG.
// If SuperAdmin enables a module in the plan, the matching route becomes accessible
// regardless of RBAC - RBAC only controls action-level buttons inside the page.
export const pathToSidebarModuleSlug = (path = "") => {
  const p = String(path || "").toLowerCase();
  // Expense Management routes are plan-mapped. Checked BEFORE the generic
  // "/dashboard" slug below, which "/expense/dashboard" would otherwise match.
  if (p.includes("/expense/dashboard")) return "expense_dashboard";
  if (p.includes("/expense/advances")) return "expense_advance";
  if (p.includes("/expense/submit")) return "expense_submission";
  if (p.includes("/expense/approvals")) return "expense_approval";
  if (p.includes("/expense/reports")) return "expense_reports";
  if (p.includes("/expense/config")) return "expense_configuration";
  if (p.endsWith("/dashboard")) return "dashboard";
  if (p.endsWith("/my-in-out")) return "my_in_out";
  if (p.includes("/compoff-leave-application")) return "leave_application";
  if (p.endsWith("/leave-application")) return "leave_application";
  if (p.endsWith("/employee-attendence-regularization")) return "attendance_regularization";
  if (p.endsWith("/resignation")) return "resignation";
  if (p.endsWith("/tickets")) return "tickets";
  if (p.endsWith("/user-assets")) return "user_assets";
  if (p.endsWith("/user-reports")) return "user_reports";
  if (p.endsWith("/individual-rank")) return "individual_rank";
  if (p.endsWith("/bill-reimbursement")) return "bill_reimbursement";
  if (p.includes("/employee-master") || p.includes("/employee-overview")) return "employee_master";
  if (p.endsWith("/employee-in-out")) return "employee_in_out";
  if (p.endsWith("/resignation-employee-list")) return "resignation_employee_list";
  if (p.endsWith("/last-working-day-emps")) return "resignation";
  if (p.endsWith("/admin-reports")) return "admin_reports";
  if (p.endsWith("/employee-tickets")) return "employee_tickets";
  if (p.endsWith("/admin-leave-approval")) return "admin_leave_management";
  if (p.endsWith("/user-leave-approve")) return "user_leave_management";
  // Checked before /penalty-revoke - endsWith would match the user path too.
  if (p.endsWith("/user-penalty-revoke")) return "user_leave_management";
  if (p.endsWith("/penalty-revoke")) return "admin_leave_management";
  if (p.endsWith("/pending-task-list")) return "pending_task";
  if (p.endsWith("/admin-regularizatrion")) return "admin_regularization";
  if (p.endsWith("/manage-team-regularization")) return "manage_team_regularization";
  if (p.endsWith("/company-doc-master")) return "doc_master";
  if (p.endsWith("/onboarding-master")) return "onboarding_master";
  if (p.endsWith("/candidate-approval-master")) return "candidate_approval_master";
  if (p.endsWith("/onboarding-initiation-master")) return "onboarding_initiation_master";
  if (p.endsWith("/employee-master-form-builder")) return "employee_master_form_builder";
  if (p.endsWith("/rejoin-employee-form-builder")) return "rejoin_employee_form_builder";
  if (p.endsWith("/candidate-approval")) return "candidate_approval";
  // ATS module (everything except Talent Pool) and Talent Pool itself all ride
  // the single "ats_tracking" plan slug. Checked before the generic "/jobs/" match below.
  if (p.endsWith("/ats-tracking") || p.includes("/ats-tracking/")) return "ats_tracking";
  if (p.endsWith("/talent-pool")) return "ats_tracking";
  if (p.endsWith("/ats-reports")) return "ats_tracking";
  if (p.endsWith("/candidates") || p.includes("/candidates/view/")) return "ats_tracking";
  if (p.includes("/jobs/") && (p.endsWith("/applications") || p.endsWith("/screening-questions"))) return "ats_tracking";
  if (p.endsWith("/interviews") || p.endsWith("/my-assigned-interviews")) return "ats_tracking";
  if (p.endsWith("/background-verification")) return "ats_tracking";
  if (p.endsWith("/ai-parsing") || p.endsWith("/ai-matching")) return "ats_tracking";
  if (p.endsWith("/candidate-list")) return "candidate_list";
  if (p.endsWith("/onboarding-initiation")) return "onboarding_initiation";
  if (p.endsWith("/doc-approve-list")) return "doc_approve_list";
  if (p.endsWith("/new-joinees-list")) return "new_joinees_list";
  if (p.endsWith("/mood-list")) return "mood_analytics";
  if (p.includes("/jobs/")) return "job_opening";
  if (p.endsWith("/inventory")) return "inventory";
  if (p.endsWith("/viewemployeedetails")) return "employee_details";
  if (p.endsWith("/organization-policy")) return "organization_policy";
  if (p.includes("/admin-bill-reimbursement")) return "admin_bill_reimbursement";
  if (p.includes("/engage/announcements")) return "announcement";
  if (p.includes("/engage/celebrations")) return "celebration";
  if (
    p.includes("/engage/wall") ||
    p.includes("/engage/awards") ||
    p.includes("/engage/badges") ||
    p.includes("/engage/moderation") ||
    p.includes("/engage/settings")
  ) return "wall";
  if (p.endsWith("/announcement") || p.endsWith("/announcement-category")) return "announcement";
  if (p.endsWith("/360-survey") || p.includes("/survey-form")) return "360_survey";
  if (p.endsWith("/360-questionnaire") || p.includes("/add/new-questionnaire")) return "questionnaire";
  if (p.endsWith("/360-reviews") || p.includes("/add/new-review") || p.includes("/360_reports")) return "360_reviews";
  if (p.endsWith("/activity-logs")) return "activity_logs";
  if (p.endsWith("/admin/zoho-payroll-integration")) return "zoho_payroll_integration";
  if (p.endsWith("/organization-view")) return "organization_tree";
  if (p.endsWith("/mira")) return "mira_ai";
  // Every Skills screen shares one RBAC resource and one plan slug.
  if (p.endsWith("/skills") || p.endsWith("/skills-matrix") || p.endsWith("/skill-inventory") || p.includes("/view-skill-inventory/") || p.endsWith("/role-skill-requirements") || p.endsWith("/skill-gap-analysis")) return "skill_master";
  // Career Growth Path screens share the CAREER_PATH resource and one plan slug.
  if (
    p.endsWith("/career-paths") ||
    p.includes("/career-path-builder/") ||
    p.endsWith("/employee-career-paths") ||
    p.endsWith("/career-role-requirements") ||
    p.endsWith("/course-skill-mapping") ||
    p.endsWith("/employee-career-view") ||
    p.endsWith("/career-readiness") ||
    p.endsWith("/competencies") ||
    p.endsWith("/employee-competencies")
  ) return "career_path";
  if (p.includes('/lms/')) return "learning";
  if (p.includes('/performance/')) return "performance";
  return "";
};

export const hasPlanRouteAccess = (path = "") => {
  try {
    const raw = JSON.parse(localStorage.getItem("sidebarModuleAccess") || "[]");
    const sidebarModuleAccess = new Set(Array.isArray(raw) ? raw : []);
    // No plan configured - do not override RBAC
    if (sidebarModuleAccess.size === 0) return false;
    const slug = pathToSidebarModuleSlug(path);
    return slug ? sidebarModuleAccess.has(slug) : false;
  } catch {
    return false;
  }
};
